/**
 * The session. One call, and everything the shell needs to render.
 */

import { client } from "@/lib/api/client";
import type { components } from "@/lib/api/schema";

export type Me = components["schemas"]["MeOut"];
export type MePermissions = components["schemas"]["MePermissions"];
export type UserStatus = "uncommissioned" | "active" | "deactivated";

export function fetchMe(): Promise<Me> {
  return client.request<Me>("/auth/me");
}

export function logout(): Promise<void> {
  return client.request<void>("/auth/logout", { method: "POST" });
}

/**
 * Where to send someone to sign in, with a path to come back to.
 *
 * The server refuses anything that is not same-origin, so a tampered
 * `redirect` lands on `/` rather than off-site — but building it from
 * `location` here means the honest case never trips that check.
 */
export function loginUrl(idp: "google" | "microsoft", returnTo?: string): string {
  const params = new URLSearchParams({ idp });
  if (returnTo !== undefined && returnTo !== "") params.set("redirect", returnTo);
  return `/auth/login?${params.toString()}`;
}
